import { ServiceData } from '@/types';

import articles from './ASTROLOGY_ARTICLES_LV.json';
import audios from './ASTROLOGY_AUDIOS_LV.json';

export const ASTROLOGY_DATA_LV: ServiceData = {
  articles,
  audios,
};
